export default __webpack_public_path__ + "static/2440-f2effcd8166002fd65597efcfcf2b070.gif";